/* eslint-env browser */
import logger from '../logger'
import { isEmpty } from 'lodash-es'
import extendedObservable from './base'
import analyticsUtil from '../metrics/analytics-util'
import AnalyticsStrings from '../metrics/strings'


// ////////////
// Analytics //
// ////////////

export function AnalyticsObservable() {
  extendedObservable(this, 'analyticsModel');

  // initialize metrics
  analyticsUtil.init();

  let validationMessages = [];
  window.utag_data = window.utag_data || {};

  const createAnalyticsPayload = async (data, productStringType, isApplePayExpressConfirmation) => {
    const standardPageViewData = AnalyticsStrings.getStandardPageViewData();

    if (isApplePayExpressConfirmation) {
      return { ...data, ...standardPageViewData };
    }

    const productData = analyticsUtil.parseProductInfo(this.orderModel, productStringType)
    const userData = await analyticsUtil.getUserInfo(this.orderModel);

    return { ...data, ...standardPageViewData, ...productData, ...userData };
  }

  const sendPageView = async (data, pageViewType) => {
    if (isEmpty(this.orderModel) || isEmpty(this.orderModel.lineItems)) {
      logger(`ANALYTICS :: no product data available - ${data.pageName}`, 'warning')();
    } else {
      const analyticsPayload = await createAnalyticsPayload(data, pageViewType);
      const utagData = Object.assign(window.utag_data, analyticsPayload);

      // Add checkoutType conditionally so that we only set it once per session.
      if (!utagData.checkoutType) {
        const checkoutTypeObject = analyticsUtil.getCheckoutType(this.orderModel, pageViewType);
        Object.assign(utagData, checkoutTypeObject);
      }
      if (this.appModel.membershipAutoRemoved) {
        utagData.membershipAutoRemoved = true;
        this.appModel.membershipAutoRemoved = false;
      }
      analyticsUtil.sendView(utagData);
    }
  }

  // register and unregister event listeners
  this.on('registerAnalyticsObserver', observer => this.registerObserver(observer))
  this.on('unregisterAnalyticsObserver', observer => this.unregisterObserver(observer))

  this.on('analytics.sendClick', (data, e) => {
    let errorCodes = ''
    const pageName = window?.utag_data?.pageName || AnalyticsStrings.page[this.appModel.currentPageUid];
    const products = analyticsUtil.getProductString(this.orderModel)

    logger('ANALYTICS :: \'analytics.sendClick\' event', 'info')()

    if (validationMessages.length > 0) {
      validationMessages.forEach((errorCode, index) => {
        if (index > 0) errorCodes += '|'
        errorCodes += errorCode
      })
      // clear validation messages so that each click sends a distinct state
      validationMessages = []
    }

    analyticsUtil.sendClick({ errorCodes, pageName, products, ...data }, e);
  })

  this.on('analytics.sendPageView', data => sendPageView(data))
  this.on('analytics.sendConfirmationPageView', data => sendPageView(data, 'confirmation'))
  this.on('analytics.sendApplePayExpressConfirmationPageView', data => sendPageView(data, 'applePayExpressConfirmation'))

  this.on('analytics.addValidationMsg', (validationMsg) => {
    // Validation sometimes runs multiple times. This prevents error analytics from being added multiple times.
    if (validationMessages.indexOf(validationMsg) === -1) validationMessages.push(validationMsg)
  })

  this.on('analytics.clearValidationMsgs', () => {
    validationMessages = []
  })
}
